



















import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Scope } from 'spraypaint';
import { ApplicationRecord } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ default: '' })
  readonly label: string;

  @Prop({ default: '' })
  readonly placeholder: string;

  @Prop({ default: 'name' })
  readonly otherText: string;

  @Prop({ default: 'name' })
  readonly itemText: string;

  @Prop({ default: 'id' })
  readonly itemValue: string;

  @Prop({})
  readonly noDataText: string;

  @Prop({ default: false })
  readonly dark: boolean;

  @Prop({ default: false })
  readonly filled: boolean;

  @Prop({ default: false })
  readonly dense: boolean;

  @Prop({ default: false })
  readonly clearable: boolean;

  @Prop({ required: false })
  readonly rules: any;

  @Prop({ required: true })
  readonly scopeFactory: () => Scope<ApplicationRecord>;

  @Prop({})
  readonly scopeWhere: any;

  @Prop({ type: Boolean, default: false })
  readonly showOther: boolean;

  @Model('input', { type: ApplicationRecord })
  readonly value: ApplicationRecord;

  get selected() {
    return this.value;
  }

  set selected(d) {
    this.$emit('input', d);
  }

  get other() {
    if (!this.showOther) {
      return;
    }
    const obj: any = {};
    obj[this.itemValue] = '0';
    obj[this.otherText] = 'Other';
    const model = this.scopeFactory().model;
    return new model(obj);
  }

  loading: boolean = false;

  items: ApplicationRecord[] = [];

  async update(forceUpdate = false) {
    try {
      this.loading = true;
      const scope = this.scopeFactory().where(this.scopeWhere);
      const result = await scope.all();
      this.items = result.data;

      if (forceUpdate && this.selected) {
        const item = this.items.find(element => {
          return this.selected.id === element.id;
        });

        if (item) {
          this.selected = item;
        }
      }
    } catch (e) {
      this.items = [];
    } finally {
      if (this.showOther && this.other) {
        this.items.push(this.other);
      }
      this.loading = false;
    }
  }

  mounted() {
    this.update(true);
  }

  @Watch('scopeWhere')
  scopeChanged() {
    this.update();
  }
}
